var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "billing-page" },
    [
      _c("div", { staticClass: "billing-wrapper" }, [
        _c(
          "div",
          { staticClass: "billing-content" },
          [
            _c("billing-header", { staticClass: "billing-header" }),
            _c("h1", { staticClass: "mb-13" }, [
              _vm._v(" " + _vm._s(_vm.$t("pages.billing.title")) + " "),
            ]),
            _c("current-subscription", { staticClass: "mb-10" }),
            _c("payment-method", { staticClass: "mb-10" }),
            _c("billing-history"),
          ],
          1
        ),
      ]),
      _c("dialog-expired-free-trial", {
        attrs: { visible: _vm.dialogExpiredFreeTrial },
        on: {
          close: function ($event) {
            _vm.dialogExpiredFreeTrial = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }